import React, { useEffect } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import FormNotificaciones from "../../components/notificaciones/FormNotificaciones";
import Loader from "../../components/Loader";
import useNotificacionesStore from "../../store/notificacionesStore";
import { useParams, useNavigate } from 'react-router-dom';

const DetalleNotificaciones = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { isLoading, iniciar, actualizarId, setNavigate, limpiar } = useNotificacionesStore();


  useEffect(() => {
    limpiar();
    setNavigate(navigate);
    actualizarId(id);
    iniciar();
  }, []);

  return (
    <>
      <MasterLayout>
        { isLoading ? <Loader /> : <FormNotificaciones />}
      </MasterLayout>
    </>
  );
};

export default DetalleNotificaciones;
